import { handleExternalLinks } from '../helpers';

addEventListener('DOMContentLoaded', () => {
	const menuItems = document.querySelectorAll('#menu-main .menu-item.top-level > a');

	handleStates();
	handleExternalLinks(menuItems);

	// Make items on the second level unclickable
	document.querySelectorAll('.menu-item.top-level > ul > li > ul > li > a').forEach(a => {
		a.addEventListener('click', e => {
			e.preventDefault();
			e.stopPropagation();
			return false;
		});
		a.setAttribute('tabindex', '-1');
		a.setAttribute('aria-disabled', 'true');
		a.style.pointerEvents = 'none';
	});
});

function handleStates() {
	const menu = document.querySelector('#menu-main');

	if (!menu) return;

	menu.addEventListener('mouseleave', () => setBackdropHeight(0));
	menu.addEventListener('focusout', () => setBackdropHeight(0));
	menu.addEventListener('blur', () => setBackdropHeight(0));
	menu.querySelectorAll('.menu-item.top-level').forEach((menuItem) => {
		menuItem.addEventListener('mouseover', () => handleBackdropSize(menuItem));
		menuItem.addEventListener('focus', () => handleBackdropSize(menuItem));
		menuItem.addEventListener('focusin', () => handleBackdropSize(menuItem));
	});
	menu.querySelectorAll('.menu-item:not(.top-level)').forEach((menuItem) => {
		menuItem.addEventListener('click', () => setBackdropHeight(0));
	});
}

function setBackdropHeight(height = 0) {
	const backdrop = document.querySelector('.mega-menu-backdrop');
	const backdropPushdown = document.querySelector('.mega-menu-backdrop-pushdown');

	if (!backdrop || !backdropPushdown) {
		return;
	}

	backdrop.classList[height === 0 ? 'remove' : 'add']('active');
	backdropPushdown.style.height = height + 'px';
}

function handleBackdropSize(menuItem) {
	const subMenu = menuItem.querySelector('.sub-menu');

	if (subMenu) {
		const container = subMenu?.querySelector('.grid-container > ul');

		if (container) {
			setBackdropHeight(container.clientHeight);
		}
	} else {
		setBackdropHeight(0);
	}
}
